import { updateAppointmentStatusIdentifier } from "utils/appointmentUtils";

import type { Appointment, COMMUNICATION_STATUSES, DealerLocation, STATUS_IDENTIFIERS } from "models";

export enum SEARCH_OPTION_TYPE {
  Claire = 1,
  Dms
}

export type AppointmentSearchOption = {
  id: string;
  dms_nr: string;
  car_make: string;
  car_model: string;
  due_in: string;
  wo_nr: string;
  reg_number: string;
  appointment_status_identifier: STATUS_IDENTIFIERS;
  dealer_location?: DealerLocation | null;
  dealer_location_id?: number;
  customcom_status?: COMMUNICATION_STATUSES | null;
  car_check_paused_at?: string | null;
  car_out_of_shop?: string | null;
  type: SEARCH_OPTION_TYPE;
};

export type SearchResultsData = {
  currentLocation: AppointmentSearchOption[];
  otherLocations: AppointmentSearchOption[];
};

export const getFormattedAndSortedSearchResults = (type: SEARCH_OPTION_TYPE) => (appointments: Appointment[]) => {
  const options: AppointmentSearchOption[] = appointments.map(searchedAppointment => {
    const appointment = updateAppointmentStatusIdentifier(searchedAppointment);

    return {
      id: appointment.id + "",
      dms_nr: appointment.dms_nr,
      car_make: appointment.car_make,
      car_model: appointment.car_model,
      due_in: appointment.time_car_app,
      wo_nr: appointment.wo_nr,
      reg_number: appointment.reg_number,
      appointment_status_identifier: appointment.appointment_status_identifier,
      dealer_location: appointment.dealer_location,
      customcom_status: appointment.customer_communication?.status,
      car_check_paused_at: appointment.car_check_paused_at,
      car_out_of_shop: appointment.car_out_of_shop,
      type,
      dealer_location_id: appointment.dealer_location_id
    };
  });

  return options.sort((a, b) => new Date(b.due_in).valueOf() - new Date(a.due_in).valueOf());
};
